<template><svg viewBox="0 0 12 13" xmlns="http://www.w3.org/2000/svg">
<path d="M-3.27835e-07 6.5L11.25 0.00480889L11.25 12.9952L-3.27835e-07 6.5Z"/>
</svg>
</template>